import { render, staticRenderFns } from "./PIIssues.vue?vue&type=template&id=c4bfc3b8&scoped=true"
import script from "./PIIssues.vue?vue&type=script&lang=js"
export * from "./PIIssues.vue?vue&type=script&lang=js"
import style0 from "./PIIssues.vue?vue&type=style&index=0&id=c4bfc3b8&prod&lang=css"
import style1 from "./PIIssues.vue?vue&type=style&index=1&id=c4bfc3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bfc3b8",
  null
  
)

export default component.exports